import { FC, useEffect, useState } from "react";
import Popover from "antd/lib/popover";
import { useHistory } from "react-router-dom";
import { getInitials, getUserData, logout } from "../../../utilities/utilities";
import { RouteConstants } from "../../../router/Constants";
import Button from "antd/lib/button";
import Divider from "antd/lib/divider";
import Avatar from "antd/lib/avatar";
import { UserAddOutlined } from "@ant-design/icons";
import Logo from "../../../Images/allure-logo.png";
import { UpCircleOutlined } from "@ant-design/icons";
import HeaderMenuComponent from "./HeaderMenu.component";

import { connect } from "react-redux";
import { RestartTour } from "../../../redux/Tour/Tour.action";
import { BUILD, BuildType } from "../../../constants/Constants";
import LogComponent from "../../../components/Log/Log.component";
import SettingsComponent from "../../../components/Settings/Settings.component";
import WelcomeModal from "../../../constants/WelcomeModal";
import { BASE_URI } from "../../../redux/ApiCall";
import { ApiCallState } from "../../../redux/Utils";
import { Document } from "../../../redux/Document/Document.type";
import { fetchOneDocument } from "../../../redux/Document/Document.action";
const HeaderComponent: FC<{
  onCollapse: Function;
  restart: Function;
  fetchDocument: Function;
  document: ApiCallState<Document>;
}> = ({ onCollapse, restart, document, fetchDocument }) => {
  const history = useHistory();

  const [data] = useState(getUserData());
  const [tour_visibility, setTourVisibility] = useState(false);

  useEffect(() => {
    if (data.document_id) {
      fetchDocument(getUserData().document_id);
    }
  }, [fetchDocument]);

  return (
    <div className="limit-container">
      <WelcomeModal setTourVisibility={setTourVisibility} />
      <div className="row">
        <div className="header-wrapper">
          <div className="header-breadcrumb">
            <img src={Logo} alt="Logo" style={{width: 160}} />
          </div>
          <HeaderMenuComponent />
          <div className="header-icons">
            {data.is_super_user ? (
              <Button
                className="pt-2"
                type="link"
                icon={<UserAddOutlined />}
                onClick={(e: any) =>
                  history.push(RouteConstants.USER_MANAGEMENT)
                }
              />
            ) : null}
            <LogComponent />
            <Popover
              overlayClassName="header-popover"
              placement="bottomRight"
              content={
                <>
                  <h6 className="con-user">{data ? data.full_name : null}</h6>
                  <h6
                    style={{
                      backgroundColor: "#6a7a9c",
                      display: "inline",
                      color: "white",

                      padding: "6px",
                      borderRadius: "8px",
                      fontSize: "10px",
                    }}
                  >
                    {BUILD === BuildType.ENTERPRISE_PROJECT
                      ? BuildType.PROJECT
                      : BUILD}
                  </h6>
                  {BUILD === BuildType.PROJECT ||
                  BUILD === BuildType.ENTERPRISE_PROJECT ? (
                    <a target="blank" href="https://condigitaleth.com/demo/">
                      <Button
                        className="d-block"
                        type="link"
                        size="middle"
                        icon={
                          <UpCircleOutlined
                            style={{ verticalAlign: "text-bottom" }}
                          />
                        }
                        style={{ paddingLeft: "0px" }}
                      >
                        Upgrade Package
                      </Button>
                    </a>
                  ) : null}

                  <SettingsComponent />

                  {/* <br></br> */}
                  <Divider style={{ marginBottom: "13px" }} />
                  <Button
                    style={{
                      paddingLeft: "0px",
                      marginTop: "0px",
                      paddingTop: "0px",
                    }}
                    className="btn btn-link"
                    onClick={() => {
                      logout();
                      history.push(RouteConstants.LOGIN);
                    }}
                  >
                    Sign Out
                  </Button>
                </>
              }
              trigger="hover"
            >
              <Avatar
                style={{ color: "#fff", backgroundColor: "#FC9A00" }}
                src={BASE_URI + "/" + document?.payload?.url || undefined}
              >
                {!document?.payload?.url && getInitials(data.full_name)}
              </Avatar>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Map State to Props
 *
 * @param state
 */
const mapStateToProps = (state: any) => ({
  document: state.document.fetchOne,
});

/**
 * Map Dispatch to Props
 *
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: any) => ({
  restart: (action: any) => dispatch(RestartTour(action)),
  fetchDocument: (action: any) => dispatch(fetchOneDocument(action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);
